export default "__VITE_ASSET___hnUh6qq__"